import React from 'react';
import { motion } from 'framer-motion';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { Calendar, Download, Filter } from 'lucide-react';
const data = [{
  month: 'Jan',
  suaLoja: 4200,
  mercado: 4100,
  concorrenteA: 4000
}, {
  month: 'Fev',
  suaLoja: 4100,
  mercado: 4150,
  concorrenteA: 3950
}, {
  month: 'Mar',
  suaLoja: 4300,
  mercado: 4200,
  concorrenteA: 4100
}, {
  month: 'Abr',
  suaLoja: 4150,
  mercado: 4250,
  concorrenteA: 4150
}, {
  month: 'Mai',
  suaLoja: 4000,
  mercado: 4100,
  concorrenteA: 4050
}, {
  month: 'Jun',
  suaLoja: 3900,
  mercado: 4000,
  concorrenteA: 3900
}, {
  month: 'Jul',
  suaLoja: 4100,
  mercado: 4150,
  concorrenteA: 4000
}];
export function History() {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} className="space-y-6" data-id="element-166">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-167">
        <div data-id="element-168">
          <h1 className="text-2xl font-bold text-navy-900" data-id="element-169">
            Histórico de Preços
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-170">
            Análise temporal de competitividade e variações
          </p>
        </div>

        <div className="flex flex-wrap gap-3 mt-4 md:mt-0" data-id="element-171">
          <div className="relative" data-id="element-172">
            <select className="appearance-none bg-white border border-slate-200 text-slate-700 py-2 pl-4 pr-10 rounded-lg focus:outline-none focus:ring-2 focus:ring-navy-900 text-sm" data-id="element-173">
              <option data-id="element-174">Últimos 6 meses</option>
              <option data-id="element-175">Último ano</option>
              <option data-id="element-176">Personalizado</option>
            </select>
            <Calendar className="absolute right-3 top-2.5 h-4 w-4 text-slate-400 pointer-events-none" data-id="element-177" />
          </div>

          <div className="relative" data-id="element-178">
            <select className="appearance-none bg-white border border-slate-200 text-slate-700 py-2 pl-4 pr-10 rounded-lg focus:outline-none focus:ring-2 focus:ring-navy-900 text-sm" data-id="element-179">
              <option data-id="element-180">Todas Categorias</option>
              <option data-id="element-181">Eletrônicos</option>
              <option data-id="element-182">Eletrodomésticos</option>
            </select>
            <Filter className="absolute right-3 top-2.5 h-4 w-4 text-slate-400 pointer-events-none" data-id="element-183" />
          </div>

          <button className="flex items-center px-4 py-2 bg-navy-900 text-white rounded-lg text-sm font-medium hover:bg-navy-800 transition-colors" data-id="element-184">
            <Download className="h-4 w-4 mr-2" data-id="element-185" />
            Exportar Relatório
          </button>
        </div>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-186">
        <h3 className="text-lg font-semibold text-navy-900 mb-6" data-id="element-187">
          Evolução Média de Preços (R$)
        </h3>
        <div className="h-[400px] w-full" data-id="element-188">
          <ResponsiveContainer width="100%" height="100%" data-id="element-189">
            <AreaChart data={data} margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0
          }} data-id="element-190">
              <defs data-id="element-191">
                <linearGradient id="colorSuaLoja" x1="0" y1="0" x2="0" y2="1" data-id="element-192">
                  <stop offset="5%" stopColor="#1B2A4A" stopOpacity={0.1} data-id="element-193" />
                  <stop offset="95%" stopColor="#1B2A4A" stopOpacity={0} data-id="element-194" />
                </linearGradient>
                <linearGradient id="colorMercado" x1="0" y1="0" x2="0" y2="1" data-id="element-195">
                  <stop offset="5%" stopColor="#64748b" stopOpacity={0.1} data-id="element-196" />
                  <stop offset="95%" stopColor="#64748b" stopOpacity={0} data-id="element-197" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} data-id="element-198" />
              <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{
              fill: '#64748b'
            }} dy={10} data-id="element-199" />
              <YAxis axisLine={false} tickLine={false} tick={{
              fill: '#64748b'
            }} tickFormatter={value => `R$ ${value}`} data-id="element-200" />
              <Tooltip contentStyle={{
              backgroundColor: '#fff',
              borderRadius: '8px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
            }} formatter={(value: number) => [`R$ ${value}`, '']} data-id="element-201" />
              <Legend verticalAlign="top" height={36} iconType="circle" data-id="element-202" />
              <Area type="monotone" dataKey="suaLoja" name="Sua Loja" stroke="#1B2A4A" strokeWidth={3} fillOpacity={1} fill="url(#colorSuaLoja)" data-id="element-203" />
              <Area type="monotone" dataKey="mercado" name="Média de Mercado" stroke="#64748b" strokeWidth={2} strokeDasharray="5 5" fillOpacity={1} fill="url(#colorMercado)" data-id="element-204" />
              <Area type="monotone" dataKey="concorrenteA" name="Concorrente Principal" stroke="#EF4444" strokeWidth={2} fill="none" data-id="element-205" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-206">
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-207">
          <p className="text-sm text-slate-500 font-medium" data-id="element-208">
            Variação no Período
          </p>
          <p className="text-3xl font-bold text-navy-900 mt-2" data-id="element-209">-2.4%</p>
          <p className="text-xs text-emerald-600 mt-1 font-medium" data-id="element-210">
            Mais competitivo que a média
          </p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-211">
          <p className="text-sm text-slate-500 font-medium" data-id="element-212">Preço Médio</p>
          <p className="text-3xl font-bold text-navy-900 mt-2" data-id="element-213">R$ 4.092</p>
          <p className="text-xs text-slate-400 mt-1" data-id="element-214">Baseado em 247 produtos</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-215">
          <p className="text-sm text-slate-500 font-medium" data-id="element-216">
            Oportunidades Identificadas
          </p>
          <p className="text-3xl font-bold text-navy-900 mt-2" data-id="element-217">18</p>
          <p className="text-xs text-amber-600 mt-1 font-medium" data-id="element-218">
            Produtos com margem para aumento
          </p>
        </div>
      </div>
    </motion.div>;
}